import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
function FacebookFBrandsGlyph(props, svgRef) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: _jsx("path", { d: "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" }, void 0) }), void 0));
}
const ForwardRef = React.forwardRef(FacebookFBrandsGlyph);
export default ForwardRef;
